import RefreshIcon from "@mui/icons-material/CachedRounded";
import { Box, Button, Stack } from "@mui/material";
import type { PropsWithChildren } from "react";
import SearchField from "@entrilia/shared/components/inputs/SearchField";
import ColumnSelector from "../columns/ColumnSelector";
import { useFilterContext } from "./FilterContext";
import FilterControl from "./FilterControl";
import Filters from "./Filters";
import { searchAction } from "./filterState";

interface Props {
  recordCount: number;
  totalCount?: number;
  isLoading?: boolean;
  isRefreshing?: boolean;
  onRefresh?: () => void;
  hasColumnSelection?: boolean;
  withoutSearch?: boolean;
}

const FiltersPanel = ({
  recordCount,
  totalCount,
  isLoading,
  isRefreshing,
  onRefresh,
  hasColumnSelection,
  withoutSearch,
  children,
}: PropsWithChildren<Props>) => {
  const { filterState, setFilterState } = useFilterContext();

  const handleSearch = (searchTerm: string) => {
    setFilterState(searchAction(searchTerm));
  };

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
        <FilterControl recordCount={recordCount} totalCount={totalCount} hideRecordCount={isLoading} />
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          {!withoutSearch && (
            <SearchField initialValue={filterState.search.value} debounceTimeMs={300} onSearch={handleSearch} />
          )}
          {onRefresh && (
            <Button
              variant="outlined"
              color="secondary"
              disabled={isLoading}
              loading={isRefreshing}
              startIcon={<RefreshIcon />}
              onClick={onRefresh}
            >
              Refresh
            </Button>
          )}
          {children}
          {hasColumnSelection && <ColumnSelector disabled={isLoading} />}
        </Stack>
      </Box>
      <Box sx={{ width: "100%", display: filterState.showFilters ? "flex" : "none", justifyContent: "space-between" }}>
        <Filters isLoading={isLoading} />
      </Box>
    </Stack>
  );
};

export default FiltersPanel;
